module.exports = __webpack_public_path__ + "static/media/nose.3742e2b9.png";